import { render, staticRenderFns } from "./detail-component-header.vue?vue&type=template&id=72a0fe56&scoped=true"
import script from "./detail-component-header.vue?vue&type=script&lang=ts"
export * from "./detail-component-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0fe56",
  null
  
)

export default component.exports